import styled from 'styled-components';
import { TabList, Tab } from 'react-tabs';

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ModalContainer = styled.div`
  background: white;
  padding: 20px;
  border-radius: 12px;
  max-width: 700px;
  width: 95%;
  max-height: 90vh;
  overflow-y: auto;
`;

export const Title = styled.h2`
  margin-bottom: 20px;
  font-size: 20px;
  color: #1f2937;
`;

export const InputGroup = styled.div`
  margin-bottom: 16px;
`;

export const Label = styled.label`
  font-size: 14px;
  font-weight: 500;
  display: block;
  margin-bottom: 6px;
  color: #374151;
`;

export const Input = styled.input`
  width: 100%;
  padding: 10px 12px;
  font-size: 14px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: white;
`;

export const Select = styled.select`
  width: 100%;
  padding: 10px 12px;
  font-size: 14px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: white;
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
`;

export const Button = styled.button`
  padding: 10px 16px;
  font-size: 14px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  background-color: #2563eb;
  color: white;

  &:hover {
    background-color: #1e40af;
  }
`;

export const CancelButton = styled(Button)`
  background-color: #e5e7eb;
  color: #1f2937;

  &:hover {
    background-color: #d1d5db;
  }
`;

export const ImagePreview = styled.img`
  max-width: 150px;
  border-radius: 6px;
  margin-top: 8px;
`;

export const ErrorMessage = styled.p`
  color: red;
  font-size: 14px;
  margin-top: 10px;
`;

export const StyledTabList = styled(TabList)`
  list-style: none;
  display: flex;
  gap: 6px;
  margin-bottom: 16px;
  padding-left: 0;
`;

export const StyledTab = styled(Tab)`
  padding: 6px 12px;
  cursor: pointer;
  background: #f3f4f6;
  border: none;
  border-radius: 4px;
  font-size: 14px;

  &.react-tabs__tab--selected {
    background: #cf0505;
    color: white;
  }
`;

StyledTabList.tabsRole = 'TabList';
StyledTab.tabsRole = 'Tab';

export const Erro = styled.p`
  color: red;
  margin-top: 10px;
  font-size: 14px;
`;